module.exports = __webpack_public_path__ + "static/media/hotel.717c0ba4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel.svg
// module id = 274
// module chunks = 0